"use client";

// packages/eden-list/src/components/Unordered.jsx
import styled from "styled-components";
import shared from './shared.js';
import { jsx } from "react/jsx-runtime";
var unorderedStyles = {
  disc: "disc",
  circle: "circle",
  square: "square"
};
var Ul = styled.ul`
  ${shared};
  list-style-type: ${({ $listStyle }) => unorderedStyles[$listStyle]};
`;
var Unordered = ({ children, listStyle = "disc", ...props }) => /* @__PURE__ */ jsx(Ul, { $listStyle: listStyle, ...props, children });
Unordered.displayName = "Unordered";
var Unordered_default = Unordered;
export {
  Unordered_default as default
};
